import { BAvatar } from './avatar'
import { pluginFactory } from '../../utils/plugins'

const AvatarPlugin = /*#__PURE__*/ pluginFactory({
  components: { BAvatar }
})

export { AvatarPlugin, BAvatar }
